import { createAction } from '@reduxjs/toolkit';
import type { AgsReportCountry } from '~/exportReport/exportReport.constants';
import type { ReportTemplate } from '~/exportReport/template/reportTemplate';
import type { ExportReportActiveParams } from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.state';

export const exportReportEnable = createAction(
  'MAP_SETTINGS_EXPORT_REPORT_ENABLE',
  (params: ExportReportActiveParams) => ({
    payload: { params },
  })
);

export const exportReportDisable = createAction(
  'MAP_SETTINGS_EXPORT_REPORT_DISABLE',
);

export const exportReportSetSettings = createAction(
  'MAP_SETTINGS_EXPORT_SET_SETTINGS',
  (settings: { template: ReportTemplate; country: AgsReportCountry; isSampleReport: boolean }) => ({
    payload: { settings },
  })
);
